import { createSlice } from "@reduxjs/toolkit";

const trendingProductsSlice = createSlice({
  name: "trendingProducts",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    setTrendingProductsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setTrendingProducts(state, action) {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setTrendingProductsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  setTrendingProductsLoading, 
  setTrendingProducts, 
  setTrendingProductsError 
} = trendingProductsSlice.actions;

export default trendingProductsSlice.reducer;